import { gql } from "@apollo/client";

export const GET_OPERATOR_ROLES = gql`
	query ($operatorId: ID!) {
		allOperatorAccountRoles(operatorId: $operatorId) {
			operatorAccountRoleId
			roleName
			operator {
				operatorId
			}
		}
	}
`;

export const DELETE_OPERATOR_ACCOUNT = gql`
	mutation ($operatorAccountId: ID!) {
		deleteOperatorAccount(operatorAccountId: $operatorAccountId) {
			success
		}
	}
`;

export const DELETE_OPERATOR_ROLE_MUTATION = gql`
	mutation ($operatorAccountRoleId: ID!) {
		deleteOperatorAccountRole(operatorAccountRoleId: $operatorAccountRoleId) {
			success
			message
		}
	}
`;
